import type { Locale } from "../site";

export interface UiCopy {
  languageName: string;
  alternateLanguageName: string;
  skipToContent: string;
  navigationLabel: string;
  home: string;
  getTheApps: string;
  legalDocuments: string;
  heroEyebrow: string;
  heroTitle: string;
  heroBody: string;
  heroAction: string;
  heroSecondaryAction: string;
  trustEthiopia: string;
  trustLanguages: string;
  trustBandwidth: string;
  appsEyebrow: string;
  appsTitle: string;
  appsBody: string;
  riderTitle: string;
  riderBody: string;
  driverTitle: string;
  driverBody: string;
  availableSoon: string;
  storeLinksLabel: string;
  downloadOn: string;
  googlePlay: string;
  appStore: string;
  comingSoon: string;
  legalEyebrow: string;
  legalTitle: string;
  riderDocuments: string;
  driverDocuments: string;
  privacyPolicy: string;
  terms: string;
  lastUpdated: string;
  tableOfContents: string;
  backToHome: string;
  providerLine: string;
  addressLabel: string;
  footerTagline: string;
  rightsReserved: string;
  notFoundTitle: string;
  notFoundBody: string;
}

export const UI_COPY: Record<Locale, UiCopy> = {
  en: {
    languageName: "English",
    alternateLanguageName: "አማርኛ",
    skipToContent: "Skip to content",
    navigationLabel: "Main navigation",
    home: "Home",
    getTheApps: "Get the apps",
    legalDocuments: "Legal",
    heroEyebrow: "Made for everyday movement in Ethiopia",
    heroTitle: "Your ride. Your city. Yegna.",
    heroBody:
      "Request a ride or send a package with Yegna Rider. Ready to drive? Get trip offers and manage your work with Yegna Driver.",
    heroAction: "Choose your app",
    heroSecondaryAction: "Read our policies",
    trustEthiopia: "Built for Ethiopia",
    trustLanguages: "English & Amharic",
    trustBandwidth: "Low-bandwidth ready",
    appsEyebrow: "Two apps. One Yegna.",
    appsTitle: "Choose the app that moves you",
    appsBody: "Your next trip—or your next earning opportunity—starts here.",
    riderTitle: "Yegna Rider",
    riderBody: "Book a ride, send a package, and follow each trip from your phone.",
    driverTitle: "Yegna Driver",
    driverBody: "Go online, receive eligible trip offers, and manage your work in one place.",
    availableSoon: "Store links will be available soon",
    storeLinksLabel: "App stores",
    downloadOn: "Download on",
    googlePlay: "Google Play",
    appStore: "App Store",
    comingSoon: "Coming soon",
    legalEyebrow: "Clear terms, in your language",
    legalTitle: "Legal documents",
    riderDocuments: "Rider app",
    driverDocuments: "Driver app",
    privacyPolicy: "Privacy Policy",
    terms: "Terms and Conditions",
    lastUpdated: "Last updated",
    tableOfContents: "On this page",
    backToHome: "Back to home",
    providerLine: "YegnaTaxi is provided by AD Technologies and Trading.",
    addressLabel: "Business address",
    footerTagline: "Everyday movement, made for Ethiopia.",
    rightsReserved: "All rights reserved.",
    notFoundTitle: "This page could not be found",
    notFoundBody: "The address may be incorrect or the page may have moved.",
  },
  am: {
    languageName: "አማርኛ",
    alternateLanguageName: "English",
    skipToContent: "ወደ ዋናው ይዘት ይሂዱ",
    navigationLabel: "ዋና ማሰሻ",
    home: "መነሻ",
    getTheApps: "መተግበሪያዎቹን ያግኙ",
    legalDocuments: "ሕጋዊ ሰነዶች",
    heroEyebrow: "ለኢትዮጵያ ዕለታዊ ጉዞ የተዘጋጀ",
    heroTitle: "ጉዞዎ። ከተማዎ። የእርስዎ የኛ።",
    heroBody:
      "በYegna Rider ጉዞ ይጠይቁ ወይም ጥቅል ይላኩ። ለማሽከርከር ዝግጁ ነዎት? በYegna Driver የጉዞ ጥያቄዎችን ይቀበሉ እና ሥራዎን ያስተዳድሩ።",
    heroAction: "መተግበሪያዎን ይምረጡ",
    heroSecondaryAction: "ፖሊሲዎቻችንን ያንብቡ",
    trustEthiopia: "ለኢትዮጵያ የተሠራ",
    trustLanguages: "እንግሊዝኛ እና አማርኛ",
    trustBandwidth: "አነስተኛ ዳታ የሚጠቀም",
    appsEyebrow: "ሁለት መተግበሪያዎች። አንድ የኛ።",
    appsTitle: "የሚያንቀሳቅስዎትን መተግበሪያ ይምረጡ",
    appsBody: "ቀጣዩ ጉዞዎ ወይም ቀጣዩ የገቢ ዕድልዎ ከዚህ ይጀምራል።",
    riderTitle: "Yegna Rider",
    riderBody: "ጉዞ ይያዙ፣ ጥቅል ይላኩ እና እያንዳንዱን ጉዞ በስልክዎ ይከታተሉ።",
    driverTitle: "Yegna Driver",
    driverBody: "መስመር ላይ ይግቡ፣ የሚመጥኑ የጉዞ ጥያቄዎችን ይቀበሉ እና ሥራዎን በአንድ ቦታ ያስተዳድሩ።",
    availableSoon: "የመደብር ማያያዣዎች በቅርቡ ይገኛሉ",
    storeLinksLabel: "የመተግበሪያ መደብሮች",
    downloadOn: "ከዚህ ያውርዱ",
    googlePlay: "Google Play",
    appStore: "App Store",
    comingSoon: "በቅርቡ",
    legalEyebrow: "ግልጽ ውሎች፣ በቋንቋዎ",
    legalTitle: "ሕጋዊ ሰነዶች",
    riderDocuments: "የRider መተግበሪያ",
    driverDocuments: "የDriver መተግበሪያ",
    privacyPolicy: "የግላዊነት ፖሊሲ",
    terms: "ውሎች እና ሁኔታዎች",
    lastUpdated: "መጨረሻ የተሻሻለው",
    tableOfContents: "በዚህ ገጽ ላይ",
    backToHome: "ወደ መነሻ ይመለሱ",
    providerLine: "YegnaTaxi በAD Technologies and Trading ይቀርባል።",
    addressLabel: "የንግድ አድራሻ",
    footerTagline: "ለኢትዮጵያ የተዘጋጀ ዕለታዊ ጉዞ።",
    rightsReserved: "መብቱ በሕግ የተጠበቀ ነው።",
    notFoundTitle: "ይህ ገጽ አልተገኘም",
    notFoundBody: "አድራሻው የተሳሳተ ወይም ገጹ ወደ ሌላ ቦታ ተዛውሮ ሊሆን ይችላል።",
  },
};
